import React from "react";
import { Navigate } from "react-router-dom";

const AdminGuard = ({ children }) => {
  const role = localStorage.getItem("rol");
  
  if (role !== "26") { 
    return <Navigate to="/error404" replace />;
  }

  return children;
};

export default AdminGuard;